<template>
  <div id="myDateShow">
    <div class="title">{{terms.id?"修改":"新增"}} 条款信息</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">条款名称</div>
        <div class="value">
          <el-input class="w500" v-model="terms.termsName" placeholder="请填写版本名（版本号）"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">条款详情</div>
        <div class="value">
          <el-input  type="textarea"
                     :rows="20"
                     placeholder="请输入内容" v-model="terms.termsContent" style="width: 500px"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getTermsById, newVue, updateTerms} from "../../network/terms";

  export default {
    name: "TermsInsert",
    data(){
      return{
        terms: {},
        termsId: '',
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/terms/list";
      this.common.HeaderLocationTwo.name = "条款信息管理";
      this.common.HeaderLocationThree.name = "新增or修改条款信息"
      if (this.$route.params.id!=null){
        this.termsId = this.$route.params.id;

        getTermsById(this.termsId).then(res => {
          this.terms = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateTerms(this.terms).then(res => {
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
